import { DataService } from 'src/app/services/data.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { ProposalImage } from 'src/app/models/proposal-image';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { FileToBeUploaded } from 'src/app/models/internal/file-tobe-uploaded';
import { ImageToBeDeleted } from 'src/app/models/internal/image-tobe-deleted';
import { ProposalService } from 'src/app/services/proposal.service';
import { FormService } from 'src/app/services/form';
import { ProposalDocument } from 'src/app/models/proposal-document';
import { DocumentToBeDeleted } from 'src/app/models/internal/document-tobe-deleted';
import { FormFileToBeUploaded } from 'src/app/models/internal/formfile-tobe-uploaded';
import { AppSettings } from 'src/app/app.settings';
import { Constants } from 'src/app/core/constants';
import { DocumentToBeUploaded } from '../../../models/internal/document-tobe-uploaded';
import { ReasonsNonSubTestDoc } from '../../../models/reason-nonsubmission-testdoc';
import Helper from '../../../core/utility/helper';
import { BasePage } from '../../../core/basepages/allbasepages';
import { BasePageWithToolTip } from '../../../core/basepages/basepagewith-tooltip';

@Component({
    selector: 'app-proposalimages',
    templateUrl: './proposalimages.component.html',
    styleUrls: ['./proposalimages.component.scss'],
})
export class ProposalimagesComponent
    extends BasePageWithToolTip
    implements OnInit
{
    childControlTooltipText: string = '';
    @Output() private formReady: EventEmitter<FormGroup> =
        new EventEmitter<FormGroup>();
    @Output() private newImageUploaded: EventEmitter<FileToBeUploaded> =
        new EventEmitter<FileToBeUploaded>();
    @Output() private newDocumentUploaded: EventEmitter<DocumentToBeUploaded> =
        new EventEmitter<DocumentToBeUploaded>();
    @Output() private imageDeleteClicked: EventEmitter<ImageToBeDeleted> =
        new EventEmitter<ImageToBeDeleted>();
    @Output() private documentDeleteClicked: EventEmitter<DocumentToBeDeleted> =
        new EventEmitter<ImageToBeDeleted>();
    @Input() OkTOUploadImages: boolean;
    @Input() isUpdateMode: boolean;
    @Input() isSupplier: boolean;

    @Input() PrimaryLevel: any;
    @Input() SecondaryLevel: any;
    @Input() TertiaryLevel: any;
    proposalForMultipleParts: boolean = false;
    // proposalHasTestingDocuments: boolean = false;
    createproposalDTO: CreateProposalDTO;
    proposalImagesMainForm: FormGroup;
    partImages: ProposalImage[] = [];
    packageImages: ProposalImage[] = [];
    packageDocuments: ProposalDocument[] = [];
    testingDocuments: ProposalDocument[] = [];
    proposalId: number;
    otherReasonNonSubTestDocSelected: boolean = false;
    public formErrors = {
        itemsSelected: '',
        ReasonsNonSubTestDocId: null,
    };
    constructor(
        private fb: FormBuilder,
        private toastService: ToastService,
        private proposalService: ProposalService,
        private appSettings: AppSettings,
        public FormService: FormService,
        public dataService: DataService
    ) {
        super();
        this.proposalImagesMainForm = this.fb.group({
            itemsSelected: [null],
            ReasonsNonSubTestDocId: [null],
            NonSubTestDocReason: [null],
            TestDocComment: [null],
        });
    }
    public reasonsNonSubTestDocList: ReasonsNonSubTestDoc[];

    ngOnInit() {
        this.proposalService.createProposalDTO.subscribe((prop) => {
            if (prop) {
                this.setControlValues(prop);
                // this.proposalHasTestingDocuments = this.testingDocuments.length > 0;
                this.partImages.forEach((x) => {
                    this.dataService
                        .getImageFile(x.Id.toString())
                        .subscribe((y: any) => {
                            if (y['Success'] == true) {
                                let extension = String(
                                    y['Data']['FileName']
                                ).split('.');
                                if (extension.length >= 2) {
                                    x.DisplayUrl =
                                        'data:image/' +
                                        extension[extension.length - 1] +
                                        ';base64,' +
                                        y['Data']['Base64String'];
                                } else {
                                    x.DisplayUrl =
                                        'data:image/png' +
                                        ';base64,' +
                                        y['Data']['Base64String'];
                                }
                            }
                        });
                });
                this.packageImages.forEach((x) => {
                    this.dataService
                        .getImageFile(x.Id.toString())
                        .subscribe((y: any) => {
                            if (y['Success'] == true) {
                                let extension = String(
                                    y['Data']['FileName']
                                ).split('.');
                                if (extension.length >= 2) {
                                    x.DisplayUrl =
                                        'data:image/' +
                                        extension[extension.length - 1] +
                                        ';base64,' +
                                        y['Data']['Base64String'];
                                } else {
                                    x.DisplayUrl =
                                        'data:image/png' +
                                        ';base64,' +
                                        y['Data']['Base64String'];
                                }
                            }
                        });
                });
            }
        });
        this.proposalService.createProposalDTO.subscribe((prop) => {
            this.createproposalDTO = prop;
        });
        if (
            this.createproposalDTO.DefaultProposal &&
            this.createproposalDTO.DefaultProposal.PartInfo.Parts.length > 1
        ) {
            this.proposalForMultipleParts = true;
        }
        this.proposalService.reasonsNonSubTestDocMasterList.subscribe(
            (reasonsNonSubTestDoc) => {
                if (reasonsNonSubTestDoc) {
                    this.reasonsNonSubTestDocList = reasonsNonSubTestDoc;
                }
            }
        );

        this.formReady.emit(this.proposalImagesMainForm);
    }
    setControlValues(prop: CreateProposalDTO) {
        {
            this.proposalId = prop.DefaultProposal.ProposalId;
            this.proposalImagesMainForm.controls[
                'ReasonsNonSubTestDocId'
            ].setValue(
                prop.DefaultProposal.PackageInfo.ProposalReasonTestDoc
                    .ReasonsNonSubTestDocId
            );
            this.proposalImagesMainForm.controls['TestDocComment'].setValue(
                prop.DefaultProposal.PackageInfo.TestDocComment
            );
            // TMS-41186 set flag so 'Other' comment will be displayed if 'Other' was selected as reason.
            this.proposalImagesMainForm.controls[
                'NonSubTestDocReason'
            ].setValue(
                prop.DefaultProposal.PackageInfo.ProposalReasonTestDoc
                    .NonSubTestDocReason
            );
            this.otherReasonNonSubTestDocSelected =
                prop.DefaultProposal.PackageInfo.ProposalReasonTestDoc
                    .ReasonsNonSubTestDocId ==
                Constants.ID_OTHER_REASON_NONSUB_TESTDOC;
            if (
                prop.DefaultProposal.ImageInfo &&
                prop.DefaultProposal.ImageInfo.length > 0
            ) {
                this.partImages = prop.DefaultProposal.ImageInfo.filter(
                    (a) => a.Type == 1
                );
                this.packageImages = prop.DefaultProposal.ImageInfo.filter(
                    (a) => a.Type == 2
                );
            } else if (
                prop.DefaultProposal.ImageInfo &&
                prop.DefaultProposal.ImageInfo.length == 0
            ) {
                this.partImages = [];
                this.packageImages = [];
            }
            if (
                prop.DefaultProposal.DocumentInfo &&
                prop.DefaultProposal.DocumentInfo.length > 0
            ) {
                this.packageDocuments =
                    prop.DefaultProposal.DocumentInfo.filter(
                        (a) => a.Type == 1
                    );
                this.testingDocuments =
                    prop.DefaultProposal.DocumentInfo.filter(
                        (a) => a.Type == 2
                    );
            } else if (
                prop.DefaultProposal.DocumentInfo &&
                prop.DefaultProposal.DocumentInfo.length == 0
            ) {
                this.packageDocuments = [];
                this.testingDocuments = [];
            }
        }
    }

    isLevelExists(level: number) {
        switch (level) {
            case 2: {
                return (
                    this.SecondaryLevel &&
                    this.SecondaryLevel.value &&
                    this.SecondaryLevel.value['PackageMaterialId'] != null
                );
            }
            case 3: {
                return (
                    this.TertiaryLevel &&
                    this.TertiaryLevel.value &&
                    this.TertiaryLevel.value['PackageMaterialId'] != null
                );
            }
        }
        return true;
    }

    IsProposalHavingTestingDocuments(): boolean {
        return this.testingDocuments.length > 0;
    }

    imageUploaded(imageToBeUploaded: FileToBeUploaded) {
        this.newImageUploaded.emit(imageToBeUploaded);
    }
    invalidImageUploaded(errorMessage: string) {
        this.toastService.error(errorMessage);
    }
    documentUploaded(documentToBeUploaded: DocumentToBeUploaded) {
        this.newDocumentUploaded.emit(documentToBeUploaded);
    }

    imageDelete(imageToBeDeleted: ImageToBeDeleted) {
        this.imageDeleteClicked.emit(imageToBeDeleted);
    }

    docDelete(docToBeDeleted: DocumentToBeDeleted) {
        this.documentDeleteClicked.emit(docToBeDeleted);
    }
    getImageURL(image: ProposalImage) {
        // this.logDebug(image.Url + 'contains version = ' + image.Url.includes("/version/"));
        // if (image.Url.includes('/version/')) {
        //     return (
        //         this.appSettings.WarpStorageAPIImageBaseUrl +
        //         '/' +
        //         this.proposalId +
        //         '/file/' +
        //         image.Url
        //     );
        // } else {
        // show base64 string for create
        if (
            image.DisplayUrl == undefined ||
            image.DisplayUrl == null ||
            image.DisplayUrl === ''
        ) {
            return image.UUId;
        } else {
            return image.DisplayUrl;
        }

        // }
    }

    isImageUploaded(type: number, category: number) {
        if (category == 0) return false;
        let images = type == 1 ? this.partImages : this.packageImages;
        if (images.find((x) => x.Category == category)) return true;
        return false;
    }

    getDocumentURL(doc: ProposalDocument) {
        return (
            this.appSettings.Packaging2APIUrl +
            '/ProposalDocument/ProposalDocument?proposalDocumentId=' +
            doc.Id
        );
    }

    getDocumentFileName(doc: ProposalDocument) {
        return doc.FileName;
    }
    refreshToolTipText(code: string) {
        this.childControlTooltipText = Constants[code];
    }
    // mark flag if 'Other' is selected from the dropdown so the text box can be shown
    ReasonsNonSubTestDocChanged(id: number) {
        this.otherReasonNonSubTestDocSelected =
            id == Constants.ID_OTHER_REASON_NONSUB_TESTDOC;
    }
    ValidateForm(IsForSubmit: boolean) {
        this.proposalImagesMainForm.controls['itemsSelected'].setErrors(null);
        if (!IsForSubmit) {
            return;
        }
        if (!this.isSupplier) {
            return;
        }
        // debugger;
        if (
            (
                !(
                    this.partImages &&
                    this.partImages.length > 0 &&
                    this.packageImages &&
                    this.packageImages.length > 0
                )
            )
            || this.partImages.filter(image => image.Category > 0).length == 0 //if there is no part image categorized
        ) {
            this.proposalImagesMainForm.controls['itemsSelected'].setErrors({
                selectAtleastOneImage: true,
            });

            // this.formErrors = this.FormService.validateForm(
            //     <FormGroup>this.proposalImagesMainForm,
            //     this.formErrors
            // );
            // return;
        }
        if (!(this.testingDocuments && this.testingDocuments.length > 0)) {
            // check if reason is given
            const ReasonId =
                this.proposalImagesMainForm.controls['ReasonsNonSubTestDocId']
                    .value;
            if (!Helper.isValidIdValue(ReasonId)) {
                this.proposalImagesMainForm.controls['itemsSelected'].setErrors(
                    {
                        selectAtleastOneTestingDocument: true,
                    }
                );
            } else {
                // check for if 'other' reason is selected but text box is empty
                if (ReasonId == Constants.ID_OTHER_REASON_NONSUB_TESTDOC) {
                    if (
                        !Helper.isValidStringValue(
                            this.proposalImagesMainForm.controls[
                                'NonSubTestDocReason'
                            ].value
                        )
                    ) {
                        this.proposalImagesMainForm.controls[
                            'itemsSelected'
                        ].setErrors({
                            selectAtleastOneTestingDocument: true,
                        });
                    }
                }
            }
        }
        this.formErrors = this.FormService.validateForm(
            <FormGroup>this.proposalImagesMainForm,
            this.formErrors
        );
    }
}
